import React from 'react';
import { Link } from 'react-router-dom';

const AboutSection = () => {
    return (
        <section className="py-12 md:py-16 bg-[#fdfcfb]">
            <div className="container-x">
                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-12 lg:gap-20">

                    {/* LEFT SIDE: Heading */}
                    <div className="w-full lg:w-1/2">
                        {/* Sub-heading with Top Border to match the image */}
                        <div className="inline-flex flex-col mb-8">
                            <span className="h-[1.5px] w-full bg-brand-gold/80 mb-2"></span>
                            <p className="text-[11px] md:text-sm uppercase tracking-[0.25em] text-brand-gold font-bold leading-none">
                                About Famous Packing
                            </p>
                        </div>

                        <h2 className="font-serif text-[40px] md:text-[56px] lg:text-[64px] leading-[1.1] text-brand-dark max-w-md">
                            A legacy of craft, <br />
                            <span className="italic text-brand-brown">since 1990.</span>
                        </h2>
                    </div>

                    {/* RIGHT SIDE: Description */}
                    <div className="w-full lg:w-1/2 lg:pt-14">
                        <p className="text-gray-700 text-lg md:text-xl font-light leading-relaxed mb-10 max-w-xl">
                            FAMOUS PACKING, established in 1990, has built a strong reputation
                            as one of the finest manufacturers, traders, and suppliers of
                            premium packaging and gift boxes. We deliver high-quality products
                            using the finest materials and industry standards, ensuring
                            durability and customer satisfaction.
                        </p>

                        <Link
                            to="/about"
                            className="inline-flex items-center gap-3 text-brand-dark font-bold text-[13px] tracking-widest uppercase group transition-all"
                        >
                            <span className="border-b-2 border-brand-dark pb-1 group-hover:text-brand-brown group-hover:border-brand-brown transition-colors">
                                Learn more about us
                            </span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18" height="18"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                                className="rotate-[-45deg] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                            >
                                <path d="m5 12h14"></path>
                                <path d="m12 5 7 7-7 7"></path>
                            </svg>
                        </Link>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default AboutSection;